import React from 'react';
import './WorkflowOverview.css';

interface WorkflowOverviewProps {
  onStepClick: (step: number) => void;
  selectedStep: number | null;
}

const WorkflowOverview: React.FC<WorkflowOverviewProps> = ({ onStepClick, selectedStep }) => {
  const steps = [
    { 
      num: 1, 
      title: 'Authenticate', 
      icon: '🔐', 
      description: 'Obtain JWT Bearer token from Cognito for secure API access'
    },
    { 
      num: 2, 
      title: 'Validate File', 
      icon: '📁', 
      description: 'Select an existing project or create a new one, then upload a terrain file (DXF/XLSX/CSV) to create the project hierarchy'
    },
    { 
      num: 3, 
      title: 'Extract Data', 
      icon: '⚙️', 
      description: 'Extract pile locations and elevation data from validated file'
    },
    { 
      num: 4, 
      title: 'Run Analysis', 
      icon: '🚀', 
      description: 'Execute single configuration or batch run with Cartesian product of parameter variations'
    },
    {
      num: 5,
      title: 'Download Results',
      icon: '📥',
      description: 'Retrieve calculation results, earthwork data, and job outputs'
    },
    {
      num: 6,
      title: 'Create Map Layers',
      icon: '🗺️',
      description: 'Optional: generate deck.gl texture, elevation, terrarium, and manifest layers, each downloadable via a presigned S3 URL'
    }
  ];

  return (
    <div className="workflow-overview">
      <h2>📋 API Workflow</h2>
      <p className="workflow-subtitle">6-Step Process for Terrain Analysis</p>
      <div className="workflow-steps">
        {steps.map((step, index) => (
          <React.Fragment key={step.num}>
            <div 
              className={`workflow-step ${selectedStep === step.num ? 'selected' : ''}`}
              onClick={() => onStepClick(step.num)}
            >
              <div className="step-number">{step.num}</div>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
            {index < steps.length - 1 && (
              <div className="workflow-arrow">→</div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default WorkflowOverview;
